export default [
    {
        date: 1577906755940,
        row: 9,
        col: 9,
        segments: [
            [5, 1, 5, 9],
            [1, 5, 9, 5],
            [2, 2, 8, 8],
            [2, 8, 8, 2],
            [5, 1, 4, 4],
            [4, 4, 1, 5],
            [1, 5, 4, 6],
            [4, 6, 5, 9],
            [5, 9, 6, 6],
            [6, 6, 9, 5],
            [9, 5, 6, 4],
            [6, 4, 5, 1],
            [6, 3, 8, 2],
            [7, 4, 8, 2],
            [6, 3, 6, 4],
            [6, 4, 7, 4],
            [4, 3, 2, 2],
            [3, 4, 2, 2],
            [4, 3, 4, 4],
            [4, 4, 3, 4],
            [4, 6, 3, 6],
            [3, 6, 2, 8],
            [2, 8, 4, 7],
            [4, 7, 4, 6],
            [6, 7, 8, 8],
            [6, 7, 6, 6],
            [6, 6, 7, 6],
            [7, 6, 8, 8],
            [2, 2, 1, 5],
            [1, 5, 2, 8],
            [2, 8, 5, 9],
            [5, 9, 8, 8],
            [8, 8, 9, 5],
            [9, 5, 8, 2],
            [8, 2, 5, 1],
            [5, 1, 2, 2],
            [4, 3, 5, 1],
            [5, 1, 6, 3],
            [7, 4, 9, 5],
            [9, 5, 7, 6],
            [6, 7, 5, 9],
            [5, 9, 4, 7],
            [3, 6, 1, 5],
            [1, 5, 3, 4],
        ],
    },
    {
        date: 1430347397307,
        row: 9,
        col: 9,
        segments: [
            [2, 6, 8, 6],
            [8, 6, 8, 9],
            [8, 9, 2, 9],
            [2, 9, 2, 6],
            [3, 7, 7, 7],
            [7, 7, 7, 8],
            [7, 8, 3, 8],
            [3, 8, 3, 7],
            [3, 3, 7, 3],
            [7, 3, 7, 6],
            [3, 3, 3, 6],
            [4, 4, 6, 4],
            [6, 4, 6, 5],
            [6, 5, 4, 5],
            [4, 5, 4, 4],
            [5, 4, 5, 5],
            [4, 7, 4, 8],
            [5, 7, 5, 8],
            [6, 7, 6, 8],
            [4, 1, 6, 1],
            [4, 1, 4, 3],
            [6, 1, 6, 3],
            [5, 1, 5, 3],
        ],
    },
    {
        date: 1430347687728,
        row: 9,
        col: 9,
        segments: [
            [3, 1, 2, 2],
            [2, 2, 4, 2],
            [4, 2, 3, 1],
            [7, 1, 6, 2],
            [6, 2, 8, 2],
            [8, 2, 7, 1],
            [2, 2, 1, 4],
            [1, 4, 2, 6],
            [8, 2, 9, 4],
            [9, 4, 8, 6],
            [6, 2, 4, 2],
            [2, 6, 4, 7],
            [8, 6, 6, 7],
            [6, 7, 4, 7],
            [6, 3, 7, 3],
            [6, 3, 6, 4],
            [6, 4, 7, 4],
            [7, 4, 7, 3],
            [4, 3, 3, 3],
            [3, 3, 3, 4],
            [3, 4, 4, 4],
            [4, 4, 4, 3],
            [4, 7, 5, 8],
            [6, 7, 5, 8],
            [5, 6, 7, 5],
            [5, 6, 3, 5],
            [5, 6, 3, 6],
            [5, 6, 7, 6],
            [4, 5, 5, 6],
            [5, 6, 6, 5],
            [6, 5, 4, 5],
            [5, 6, 3, 7],
            [5, 6, 7, 7],
            [7, 1, 7, 2],
            [3, 1, 3, 2],
        ],
    },
    {
        date: 1430347989314,
        row: 9,
        col: 9,
        segments: [
            [4, 7, 5, 7],
            [5, 7, 5, 9],
            [5, 9, 4, 9],
            [4, 9, 4, 7],
            [5, 7, 6, 7],
            [4, 7, 3, 7],
            [3, 7, 3, 3],
            [6, 7, 6, 3],
            [5, 7, 4, 8],
            [4, 8, 5, 9],
            [3, 3, 4, 2],
            [6, 3, 5, 2],
            [5, 2, 4, 2],
        ],
    },
    {
        date: 1430409161253,
        row: 9,
        col: 9,
        segments: [
            [2, 8, 8, 8],
            [8, 8, 8, 5],
            [2, 8, 2, 5],
            [2, 5, 1, 5],
            [8, 5, 9, 5],
            [5, 1, 1, 5],
            [9, 5, 5, 1],
            [4, 8, 4, 6],
            [4, 6, 6, 6],
            [6, 6, 6, 8],
            [7, 5, 7, 4],
            [7, 4, 6, 4],
            [6, 4, 6, 5],
            [6, 5, 7, 5],
            [3, 5, 4, 5],
            [4, 5, 4, 4],
            [4, 4, 3, 4],
            [3, 4, 3, 5],
            [7, 3, 7, 2],
            [7, 2, 8, 2],
            [8, 2, 8, 4],
        ],
    },
    {
        date: 1487107043413,
        row: 9,
        col: 9,
        segments: [
            [2, 3, 3, 2],
            [3, 2, 4, 2],
            [4, 2, 5, 3],
            [2, 3, 4, 3],
            [4, 3, 3, 5],
            [4, 5, 5, 3],
            [5, 5, 4, 5],
            [6, 3, 5, 5],
            [6, 3, 9, 3],
            [9, 3, 8, 4],
            [8, 4, 8, 6],
            [8, 6, 7, 7],
            [3, 5, 3, 6],
            [3, 6, 4, 7],
            [4, 7, 7, 7],
            [5, 6, 6, 6],
            [6, 6, 7, 5],
            [2, 7, 4, 7],
            [7, 7, 8, 7],
        ],
    },
];
